import * as React from "react"
import { Modal, Row, Button, Form, Col, Container, Table } from "react-bootstrap"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import FormatError from "../../../formatters/FormatError"
import { APIError } from "../../../api/ObservableFromFetch"
import ExportPoolDetailsParameters from "../../../api/Randoms/RandomsModel/ExportPoolDetailsParameters"
import {ExportPoolDetails, GetPoolProgramYears} from "../../../api/Randoms/ExportPoolDetails"
import FromToDates from "../../Reports/FromToDates"
import ActionButton from "../../ActionButton"
import FormatTimestampFileName from "../../../formatters/FormatTimestampFileName"
import FileSaver from "file-saver"
import FormatDate from "../../../formatters/FormatDate"

const EXPORT_ALL = 0
const EXPORT_ACTIVE = 1
const EXPORT_INACTIVE = 2

interface PoolProgramYear{
    Value: number
    Text:string
}

interface ProgramIntervalType{
    Value: string
    Text:string
}
const ProgramIntervalTypes: ProgramIntervalType[] = [
    {Value: "Current",Text: "Current" },
    {Value: "Weekly",Text: "Weekly" },
    {Value: "Monthly",Text: "Monthly" },
    {Value: "Quarterly",Text: "Quarterly" },
    //{Value: "Custom",Text: "Custom" },
]  
interface ExportPoolDetailsModalProps {
  isConsortium: boolean
  onClose: () => void
}

interface ExportPoolDetailsModalState {
  exportRunning: boolean
  exportActiveMode:number
  programIntervalType:string
  programStartDate?: Date
  programEndDate?: Date
  poolProgramYearsLoading:boolean
  poolProgramYears: PoolProgramYear[],
  poolProgramYear: number
}


export default class ExportPoolDetailsModal extends React.Component<ExportPoolDetailsModalProps, ExportPoolDetailsModalState> {
  subscription?: Subscription

  state: ExportPoolDetailsModalState = {
    exportRunning: false,
    programIntervalType:"Current",
    exportActiveMode: EXPORT_ALL,
    poolProgramYears:[],
    poolProgramYearsLoading:false,
    poolProgramYear:0,
  }

  poolProgramYearsSubscription?: Subscription
  exportPoolsSubscription?: Subscription
  exportConsortiumsSubscription?: Subscription
  componentDidMount() {
    this.loadPoolProgramYears()
  }

  componentWillUnmount() {
    this.poolProgramYearsSubscription && this.poolProgramYearsSubscription.unsubscribe()
    this.exportPoolsSubscription && this.exportPoolsSubscription.unsubscribe()
    this.exportConsortiumsSubscription && this.exportConsortiumsSubscription.unsubscribe()
  }

    loadPoolProgramYears() {
      this.startLoading()
      this.poolProgramYearsSubscription && this.poolProgramYearsSubscription.unsubscribe()
      this.poolProgramYearsSubscription = GetPoolProgramYears(0).subscribe(
        (data: number[]) => {
          let years: PoolProgramYear[] = []
          years = years.concat(...this.state.poolProgramYears)
          const poolYears: PoolProgramYear[] = this.createPoolProgramYears(data)
          years = years.concat(poolYears)
          this.setState({
            poolProgramYears: years,
            poolProgramYearsLoading: false
          })
        },
        (error) => {
          toast.error(error?.errorData?.message || error.message)
        },
        () => {
          this.setState({ poolProgramYearsLoading: false })
  
        }
      )
    }
  
  startLoading() {
    this.setState({
      exportRunning:false,
      poolProgramYearsLoading: true,
      poolProgramYears: [{Value:0, Text:"All"}],
      poolProgramYear:0
    })
  }
  createPoolProgramYears = (years:number[]):PoolProgramYear[] =>{
    let result: PoolProgramYear[] = []
    for(let i = 0; i < years.length; i++){
        const year = years[i]
        const poolProgramYear :PoolProgramYear  = {Value:year, Text:year.toString()}
        result.push(poolProgramYear)
    }
    return result
  } 
  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error(FormatError(error))
  }

  handleExport = () => {

    this.setState({exportRunning:true})
    this.exportPoolsSubscription && this.exportPoolsSubscription.unsubscribe()
    const exportParams = this.createExportParameters()
    this.exportPoolsSubscription = ExportPoolDetails(exportParams).subscribe(
        result => {
            this.export(result)
            this.setState({ exportRunning: false })
        },
        error=> {
          this.setState({ exportRunning: false })
          toast.error(error)
        },
        (() => {
            this.setState({ exportRunning: false })
            this.props.onClose()
        })
    )
    //this.props.onClose()
  }
  
  createExportParameters = (): ExportPoolDetailsParameters => {
    const params: ExportPoolDetailsParameters = {
        ImplementationID: 0,
        PoolID: 0,
        PoolProgramID: 0,
        PoolSelectionID: 0,
        IsConsortium: this.props.isConsortium,
        ProgramIntervalType: this.state.programIntervalType,
        PoolProgramYear: this.state.poolProgramYear,
    }
    return params

  }  
    export(csv: string) {
      let fileName = "export_pools_details_" + this.state.programIntervalType;
      let yearName = "all_years"
      if(this.state.poolProgramYear > 0){
        yearName = this.state.poolProgramYear.toString()
      } 
      fileName = fileName + "_" + yearName
      fileName = FormatTimestampFileName(fileName, "csv", new Date());
      const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      FileSaver.saveAs(csvData, fileName, true)
      toast.success("CSV file downloaded successfully.")
    }

    handleClose = () => {
    this.setState({exportRunning:false})
    this.props.onClose()
  }

  onProgramIntervalTypeChange = (selected: string)=>{
    this.setState({programIntervalType:selected})
  }
  onPoolProgramYearChange = (selected: string)=>{
    let year = parseInt(selected)
    if(isNaN(year)){
        year = 0
    }
    this.setState({poolProgramYear:year})
  }

  render() {
    const { isConsortium } = this.props
    const { exportActiveMode, programIntervalType, programStartDate, programEndDate,exportRunning, poolProgramYearsLoading, poolProgramYears, poolProgramYear } = this.state

    return (
      <>
        <Modal backdrop="static" size="lg" centered show onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{`Export ${ isConsortium ? "All Consortium" : "Pool" } Details and Statistics`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Row className="mb-2 text-left">
                <Col lg={3}>Program Year:</Col>
                <Col lg={4}>
                    <Form.Control id="program_year" as="select"
                        disabled={poolProgramYearsLoading}
                        value={poolProgramYear}
                        onChange={e => this.onPoolProgramYearChange(e.target.value)}>
                        {poolProgramYears.map(el => <option value={el.Value} key={el.Value}>{el.Text}</option>)}
                    </Form.Control>
                </Col>
              </Form.Row>
              <Form.Row className="mb-2 text-left">
                <Col lg={3}>Program Interval:</Col>
                <Col lg={4}>
                    <Form.Control id="program_interval_type" as="select"
                        disabled={false}
                        value={programIntervalType}
                        onChange={e => this.onProgramIntervalTypeChange(e.target.value)}>
                        {ProgramIntervalTypes.map(el => <option value={el.Value} key={el.Value}>{el.Text}</option>)}
                    </Form.Control>
                </Col>
              </Form.Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <ActionButton variant="primary" disabled={poolProgramYearsLoading} onClick={() => this.handleExport()} spin={exportRunning} disableOnSpin={true} >Export</ActionButton>
            <ActionButton variant="secondary" disabled={false} onClick={() => this.handleClose()}>Cancel</ActionButton>
          </Modal.Footer>
        </Modal >
      </>
    )
  }
}
/*
{!poolProgramsLoading && <Row className="form-group">
          <Col xs={2}>PROGRAM YEAR:</Col>
          {<Col xs={2} md={2}>
            <Form.Control id="pool_program_id"
              as="select"
              disabled={false}
              value={selectedPoolProgramId}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => this.onPoolProgramSelect(e)}>
              {poolProgramsYear.map(item => <option value={item.PoolProgramID} key={"pool_program_" + item.PoolProgramID}>{item.Year}</option>)}
            </Form.Control>
          </Col>}
          <Col xs={4}>PROGRAM START DATE: {"01/01/" + selectedPoolYear}</Col>
          <Col xs={4}>PROGRAM END DATE: {"12/31/" + selectedPoolYear}</Col>
        </Row>}
*/